module.exports = __webpack_public_path__ + "static/thank-you@3x-fbe6b4d7c334f076917b6f094e69358f.png";